<template>
<CAccordion always-open>
  <CAccordionItem 
  v-for="(accordion) in accordionList" :key="accordion.id" 
  :item-key="accordion.id">
    <CAccordionHeader @click="queryFullDoc(accordion.id)">
      id: {{ accordion.id }}  名称: {{ accordion.name }}
    </CAccordionHeader>
    <CAccordionBody>
      <!-- 懒得写了好麻烦啊 -->
      <json-viewer
        :value="fullDoc[accordion.id]"
        :expand-depth=3
        :show-double-quotes="false"
        :show-array-index="false">
      </json-viewer>
    </CAccordionBody>
  </CAccordionItem>
</CAccordion>
</template>

<script>
import axios from "@/utils/http"
import JsonViewer from 'vue-json-viewer'
import { CAccordion } from '@coreui/vue'
import { CAccordionItem } from '@coreui/vue'
import { CAccordionHeader } from '@coreui/vue'
import { CAccordionBody } from '@coreui/vue'

export default{
  name: 'DocAccordion',
  components:{JsonViewer, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody},
  data() {
    return{
      fullDoc: {},
      // fullDoc:{1: {"\u4f24\u5bb3": {"\u5141\u8bb8\u66b4\u51fb": "\u662f", "\u5c5e\u6027": "\u666e\u901a\u653b\u51fb", "\u516c\u5f0f": "a.atk * 4 - b.def * 2", "\u7c7b\u578b": "\u4f53\u529b\u503c\u4f24\u5bb3", "\u79bb\u6563": 20}, "\u4f7f\u7528\u6548\u679c": [{"\u9644\u52a0\u72b6\u6001": "[0:\u666e\u901a\u653b\u51fb]*100%"}], "\u547d\u4e2d\u7c7b\u578b": "\u7269\u7406", "mp\u6d88\u8017": 0, "\u5907\u6ce8": "\u30b9\u30ad\u30eb\uff11\u756a\u306f\uff3b\u653b\u6483\uff3d\u30b3\u30de\u30f3\u30c9\u3092\u9078\u629e\u3057\u305f\u3068\u304d\u306b\u4f7f\u7528\u3055\u308c\u307e\u3059\u3002", "\u8fde\u7eed\u6b21\u6570": 1, "\u8303\u56f4": "\u5355\u4e2a\u654c\u4eba", "\u547d\u4e2d\u7387(%)": 100}}
    }
  },
  props:['dbName', 'colName', 'accordionList'],
  methods:{
    queryFullDoc(docId){
      if(!(docId in this.fullDoc)){
        axios.post('/'+this.dbName+'/'+this.colName, {full:'1',id:docId})
        .then(response => {this.fullDoc[docId] = response.data})
      }
    }
  },
}

</script>

<style>
</style>